<template>
  <div>
    <v-row>
      <v-col v-bind="inDialog ? {} : $defaultColWidth">
        <search-input v-model="filter.searchString" @search="search($event)" />
      </v-col>
      <v-spacer />
      <v-col cols="auto">
        <a v-if="!isLeeromgeving && !isImport" id="certificaten-link" @click="goToCertificaten()">
          {{ $t('certificaten.title') }}
          <v-icon color="primary">mdi-chevron-right</v-icon>
        </a>
        <v-btn v-if="!isImport" disabled text @click="sortAscending = !sortAscending">
          <v-icon>
            {{ sortAscending ? 'mdi-sort-ascending' : 'mdi-sort-descending' }}
          </v-icon>
        </v-btn>
        <v-btn text @click="showFilter = !showFilter">
          <v-icon> mdi-filter-menu</v-icon>
          <active-filter-indicator :filter="filter" />
        </v-btn>
        <v-btn v-if="!isImport" disabled text @click="listView = !listView">
          <v-icon>
            {{ listView ? 'mdi-view-list' : 'mdi-view-grid' }}
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <side-panel-filter
      @saveFilter="handleSave($event)"
      @cancelFilter="handleCancel"
      @reset="resetFilter"
      :is-import="isImport"
      :show-filter="showFilter"
      :saved-filter="filter"
    />
  </div>
</template>

<script lang="ts">
import { Component, Inject, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import RulesMixin from '@/mixins/RulesMixin';
import EnumConstantsMixin from '@/mixins/EnumConstantsMixin';
import SearchInput from '@/components/form/SearchInput.vue';
import MenuButtonCheckbox from '@/components/form/MenuButtonCheckbox.vue';
import AutocompleteInput from '@/components/form/AutocompleteInput.vue';
import CombinedInputWithIconButton from '@/components/form/CombinedInputWithIconButton.vue';
import ConfigHelper from '@/util/ConfigHelper';
import DateMonthPicker from '@/components/form/DateMonthPicker.vue';
import NumberInput from '@/components/form/NumberInput.vue';
import { Filter } from '@/domain/interface/Filter';
import DatePicker from '@/components/form/DatePicker.vue';
import SidePanelFilter from '@/views/partials/filter/SidePanelFilter.vue';
import FilterService from '@/services/FilterService';
import ActiveFilterIndicator from '@/views/partials/filter/ActiveFilterIndicator.vue';

@Component({
  components: {
    ActiveFilterIndicator,
    SidePanelFilter,
    DatePicker,
    NumberInput,
    DateMonthPicker,
    CombinedInputWithIconButton,
    AutocompleteInput,
    MenuButtonCheckbox,
    SearchInput,
  },
})
export default class OpdrachtFilter extends mixins(RulesMixin, EnumConstantsMixin) {
  @Inject('filterService') filterService: FilterService;
  showFilter = false;
  sortAscending = true;
  listView = false;
  filter: Filter = {} as Filter;
  isLeeromgeving = ConfigHelper.isLeeromgeving();
  @Prop({ default: false }) isImport!: boolean;
  @Prop({ default: false }) inDialog!: boolean;

  created() {
    this.filter = this.filterService.getOpdrachtFilter();
  }

  goToCertificaten() {
    this.$router.push({
      name: 'certificaten',
    });
  }

  search(searchString: string) {
    this.filter.searchString = searchString;
    this.handleSave(this.filter);
  }

  handleSave(filter: Filter) {
    this.showFilter = false;
    this.filter = filter;
    this.$emit('search', this.filter);
  }

  handleCancel() {
    this.showFilter = false;
  }

  resetFilter() {
    this.filterService.resetOpdrachtFilter();
    this.filter = this.filterService.getOpdrachtFilter();
    this.showFilter = false;
    this.$emit('search', this.filter);
  }
}
</script>
